import { Injectable } from '@angular/core';
import { of, Observable, map } from 'rxjs';
import { Inputfiledsbase } from '../../../models/inputfiledsbase';
import { TextboxQuestion } from '../../../question-textbox';
import { TextareaQuestion } from '../../../question-textarea';
import { DropdownservicesService } from '../../../../Services/Apis/Dropdownservices/dropdownservices.service';
import { MultiSelectQuestion } from '../../../question-multiselect';

@Injectable({
  providedIn: 'root',
})
export class AccordionPageService {

  constructor(private dropdownservice: DropdownservicesService) {}

  loadDropdownData(code: string): Observable<any[]> {
    return this.dropdownservice.getlookupcodesdropdown(code).pipe(
      map((res: any) => {

        const source =
          code === 'STATE_NAMES'
            ? res?.state ?? []
            : res ?? [];

        return source.map((item: any) => ({
          id: item.id,
          key:
            code === 'ACCORDION_DATA_TYPES'
              ? item.name
              : item.lookup_name,
          value: item.id,
        }));
      })
    );
  }

  getCreateAccordionPage(): Observable<Inputfiledsbase<string>[]> {
    return this.loadDropdownData('ACCORDION_DATA_TYPES').pipe(
      map((dropdownData) => [
        new TextboxQuestion({
          key: 'title',
          label: 'Title',
          required: true,
          order: 1,
        }),
        new TextboxQuestion({
          key: 'description',
          label: 'Description',
          required: false,
          order: 2,
        }),
        new MultiSelectQuestion({
          key: 'data',
          label: 'Data Type',
          required: true,
          options: dropdownData,
          order: 3,
        }),
      ])
    );
  }

  getLinkAccordionData(): Observable<Inputfiledsbase<string>[]> {
    return of([
      new TextboxQuestion({
        key: 'link',
        label: 'Link',
        required: true,
      }),
    ]);
  }

  getTextAccordionData(): Observable<Inputfiledsbase<string>[]> {
    return of([
      new TextboxQuestion({
        key: 'title',
        label: 'Title',
        required: true,
        order: 1,
      }),
      new TextareaQuestion({
        key: 'content',
        label: 'Content',
        required: true,
        order: 2,
        maxLength: 1000,
      }),
    ]);
  }
}
